import {
  Grid,
  Box,
  Card,
  IconButton,
  Input,
  InputAdornment,
  Typography,
  Stack,
} from "@mui/material";
import ConfirmationDialog from "popup/ConfirmDeleteDialog";
import React, { useState, useEffect, useReducer, useRef } from "react";
import { post } from "aws-amplify/api";
import { get } from "aws-amplify/api";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import TemplateBox from "components/TemplateBox";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close"; // Aggiungi questa importazione
import Header from "layouts/profile/components/Header";
import ConfirmDeleteDialogMessage from "popup/ConfirmDeleteDialogMessage";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridRowModes,
  useGridApiRef,
  GridToolbarExport,
  GridToolbarFilterButton,
} from "@mui/x-data-grid";
import dayjs from "dayjs";
import Button from "@mui/material/Button";
import { I18n } from "@aws-amplify/core";
import SearchIcon from "@mui/icons-material/Search";
import "assets/css/splitter-layout.css";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "components/APIStatusDialog";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { itIT } from "@mui/x-data-grid/locales";
import { deDE } from "@mui/x-data-grid/locales";
import { useTemplateController } from "context";

const reducer = (lastState, action) => {
  if (action.type === "DATA_RECEIVED") {
    const audit = action.value;
    if (Array.isArray(audit)) {
      audit.forEach((element) => {
        if (typeof element.timestamp === "number") {
          element.timestamp = dayjs(element.timestamp).format(
            "YYYY-MM-DD HH:mm"
          );
        }
      });
      return { audit: audit, fetched: true };
    }
  }
  return lastState;
};

function TypeDetails({ isOpen, onClose, rowData }) {
  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "en"
  );
  const { id } = useParams();
  const location = useLocation();
  const theme = useTheme();
  const [state, dispatch] = useReducer(reducer, {
    audit: [],
    fetched: false,
  });
  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

  const handleDeleteClicks = () => {
    if (selectedRows.length === 0) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("No rows selected for deletion"),
      });
      return;
    }
    setOpenConfirmDialog(true);
  };
  const confirmDeletion = async (selectedIds) => {
    try {
      setOpenConfirmDialog(false);
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Deleting alarm types"),
      });

      const restOperation = await tlmDeletePI(selectedIds);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Alarm Types deleted successfully"),
        });
        dispatch({
          type: "DATA_RECEIVED",
          value: state.audit.filter((row) => !selectedIds.includes(row.id)),
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to delete Alarm Type"),
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to delete Alarm Type"),
      });
    }
    // Close the status message after 2 seconds
    setTimeout(() => {
      setApiStatus((prevState) => ({ ...prevState, open: false }));
    }, 2000);
  };

  const [tableParentIsMD, setTableParentIsMD] = useState(false);
  const toolbarRef = useRef(null);

  useEffect(() => {
    const parentElement = toolbarRef.current;

    if (!parentElement) {
      console.error("toolbarRef is not correctly attached to any DOM element.");
      return;
    }

    const checkSize = (width) => {
      const breakpoint = 960; // 960px is md
      setTableParentIsMD(width < breakpoint);
    };

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        checkSize(entry.contentRect.width);
      }
    });

    resizeObserver.observe(parentElement);

    // Check the initial size
    checkSize(parentElement.offsetWidth);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowModes.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const apiRef = useGridApiRef();
  const [searchText, setSearchText] = useState("");
  const [openLanguageDialog, setOpenLanguageDialog] = useState(false);
  const [rowModesModel, setRowModesModel] = useState({});

  const columns = [
    { field: "alarm_text", headerName: I18n.get("Alarm Text"), width: 800 },
  ];

  const handleRowSelection = (ids) => {
    setSelectedRows(ids);
  };
  const processRowUpdate = (newRow) => {
    const updatedRows = state.audit.map((row) =>
      row.alarm_type_id === newRow.alarm_type_id ? newRow : row
    );
    dispatch({ type: "DATA_RECEIVED", value: updatedRows });
    return newRow;
  };

  const fetchLists = async () => {
    try {
      const restOperation = get({
        apiName: "TelemonitoringAPI",
        path: "/alarm/map",
        options: {
          body: {},
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          queryParams: {
            alarm_type_id: rowData.alarm_type_id,
          },
        },
      });
      const { body } = await restOperation.response;
      const response = await body.json();

      dispatch({ type: "DATA_RECEIVED", value: response });
    } catch (error) {
      console.error("Errore durante la chiamata API:", error);
    }
  };

  useEffect(() => {
    if (rowData && rowData.alarm_type_id) {
      fetchLists();
    }
  }, [rowData]);

  const filteredRows = state.audit.filter((value) => {
    if (searchText) {
      const searchTextLower = searchText.toLowerCase();
      return Object.values(value).some((val) =>
        String(val).toLowerCase().includes(searchTextLower)
      );
    }
    return true;
  });

  const searchChanged = (event) => {
    setSearchText(event.target.value);
  };

  useEffect(() => {
    const hiddenColumns = JSON.parse(
      localStorage.getItem("hiddenColumns") || "[]"
    );
    if (apiRef.current) {
      apiRef.current.setColumnVisibilityModel(
        hiddenColumns.reduce((model, field) => {
          model[field] = false;
          return model;
        }, {})
      );
    }
  }, [apiRef]);

  const handleColumnVisibilityChange = (newModel) => {
    const hiddenColumns = Object.keys(newModel).filter(
      (field) => !newModel[field]
    );
    localStorage.setItem("hiddenColumns", JSON.stringify(hiddenColumns));
  };

  const tlmDeletePI = async (ids) => {
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/alarm/map/remove",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: {
            map_ids: ids,
          },
        },
      });

      return restOperation;
    } catch (error) {}
  };
  const [controller] = useTemplateController();
  const { darkMode } = controller;
  const renderToolbar = () => {
    return (
      <div ref={toolbarRef}>
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          sx={{ pb: 2 }}
        ></Stack>

        <Stack
          direction={tableParentIsMD ? "column" : "row"}
          alignItems="center"
          justifyContent={tableParentIsMD ? "center" : "space-between"}
          spacing={2}
          sx={{ pb: 2 }}
        >
          <Stack
            direction={tableParentIsMD ? "column" : "row"}
            spacing={2}
            sx={{ width: "100%" }}
          >
            <Button
              onClick={handleDeleteClicks}
              color="primary"
              variant="outlined"
              startIcon={<DeleteIcon />}
              disabled={selectedRows.length === 0} // Disable if no rows are selected
            >
              {I18n.get("Delete Alarms Message")}
            </Button>
          </Stack>
          <Input
            type="text"
            placeholder={I18n.get("Search")}
            onChange={searchChanged}
            fullWidth={tableParentIsMD}
            endAdornment={
              <InputAdornment position="end">
                <IconButton>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
        </Stack>
      </div>
    );
  };
  function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) {
      return "Firefox";
    } else if (userAgent.includes("Edg")) {
      return "Edge";
    } else if (userAgent.includes("Chrome")) {
      return "Chrome";
    }
  }
  const browser = getBrowserName();
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ p: 2, position: "relative" }}>
            <Box
              sx={{
                position: "sticky",
                top: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                zIndex: 10,
                bgcolor: darkMode ? "#1f2020" : "background.paper",
                p: 2,
                borderRadius: 2, // Adds rounded corners
                boxShadow: 1, // Adds shadow similar to a card
              }}
            >
              <Typography variant="h5" mt={0.5} mb={1}>
                {I18n.get("Alarms Message")}
              </Typography>

              <Box>
                <IconButton color="secondary" onClick={onClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
            </Box>
            {renderToolbar()}
            <Box
              sx={{
                height: browser === "Chrome" ? "61rem" : "60rem",
                width: "100%",
              }}
            >
              <DataGridPro
                localeText={
                  language === "it"
                    ? itIT.components.MuiDataGrid.defaultProps.localeText
                    : language === "ge"
                    ? deDE.components.MuiDataGrid.defaultProps.localeText
                    : ""
                }
                rows={filteredRows}
                columns={columns}
                autoPageSize
                pagination
                getRowId={(row) => row.id || `${row.alarm_type_id}-${row.id}`} // Assicura un id univoco
                editMode="row"
                initialState={{
                  density: "compact",
                  pinnedColumns: { right: ["action"] },
                }}
                rowModesModel={rowModesModel}
                checkboxSelection
                onRowSelectionModelChange={(newSelection) =>
                  handleRowSelection(newSelection)
                }
                onRowModesModelChange={(newModel) => setRowModesModel(newModel)}
                onRowEditStop={handleRowEditStop}
                processRowUpdate={processRowUpdate}
                apiRef={apiRef}
                onColumnVisibilityModelChange={handleColumnVisibilityChange}
                slots={{
                  toolbar: () => (
                    <GridToolbarContainer>
                      <GridToolbarExport
                        printOptions={{ disableToolbarButton: true }}
                        csvOptions={{
                          fileName: "Alarms Message",
                          utf8WithBom: true,
                        }}
                      />
                      <GridToolbarFilterButton />
                    </GridToolbarContainer>
                  ),
                }}
              />
            </Box>
          </Box>
        </Grid>
      </Grid>
      <ConfirmDeleteDialogMessage
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={confirmDeletion} // Pass the selected rows' IDs to confirmDeletion
        selectedIds={selectedRows} // Pass selected rows
        parent="alarm_message"
      />
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </>
  );
}

TypeDetails.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object.isRequired,
};

export default TypeDetails;
